import React, { FunctionComponent, useCallback } from 'react'

import styled from 'styled-components'

import { SportEntity as SportEntityType } from '@utils/entities'
import useFeatureFlagsSkeleton from '@hooks/useFeatureFlagsSkeleton'
import useFollowMyTeam from '@hooks/useFollowMyTeam'
import IconButton from '@components/Buttons/IconButton'
import SportEntity from '@components/SportEntity'

interface FollowMyTeamSportEntityProps {
  sportEntity: SportEntityType
  onFollowClick?: (sportEntity: SportEntityType) => void
  onUnfollowClick?: (sportEntity: SportEntityType) => void
  hasLink?: boolean
}

const StyledIcons = styled.div`
  display: flex;
  margin-left: auto;
`

const FollowMyTeamSportEntity: FunctionComponent<
  FollowMyTeamSportEntityProps
> = ({ sportEntity, hasLink = false, onFollowClick, onUnfollowClick }) => {
  const { isFollowMyTeamEnabled } = useFeatureFlagsSkeleton()

  const { isFollowing: isFollowingFn, toggleFollow } = useFollowMyTeam({
    entityType: 'competitor',
  })

  const isFollowing = isFollowingFn(sportEntity.entityId)

  const handleToggleFollowing = useCallback(() => {
    toggleFollow(sportEntity)

    if (isFollowing) {
      onUnfollowClick?.(sportEntity)
    } else {
      onFollowClick?.(sportEntity)
    }
  }, [sportEntity, toggleFollow, isFollowing, onFollowClick, onUnfollowClick])

  return (
    <SportEntity
      name={sportEntity.title}
      image={sportEntity.image}
      link={hasLink ? sportEntity.link : undefined}>
      {isFollowMyTeamEnabled && sportEntity.isFollowingEnabled && (
        <StyledIcons>
          <IconButton
            iconName={isFollowing ? 'check-circle-solid' : 'plus-circle'}
            ariaLabel={isFollowing ? 'unfollow' : 'follow'}
            iconSize={24}
            buttonSize={48}
            onClick={handleToggleFollowing}
          />
        </StyledIcons>
      )}
    </SportEntity>
  )
}

export default FollowMyTeamSportEntity
